import { Component, Input } from '@angular/core';

import { HisAuthService } from 'hisng';

import { Patent } from 'app/fs/res/patent/model/patent/patent';

@Component({
    selector: 'res-patent-view-inventors-details',
    templateUrl: './patent-view-inventors-details.component.html',
})
export class PatentViewInventorsDetailsComponent {
    @Input() patent: Patent = new Patent(); // ngModel

    showAllInventors = false;

    // Maps containing information regarding the visibility of links to other detail pages
    checkedPersonIdsForRights = new Map();

    constructor( public auth: HisAuthService ) { }

    // used in html, too
    checkForViewPersonProfileRights(id: number) {
        return this.checkedPersonIdsForRights.get(id);
    }
}
